var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-warpper flex align-center justify-between"},[_c('div',{staticClass:"title-text flex align-center"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.pageTitle)}})]),(_vm.isBack)?_c('el-button',{attrs:{"size":"medium","plain":"","type":"primary"},on:{"click":_vm.back}},[_vm._v(" 返回上一页 ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }